<template>

	<div class="level-block">

		<div class="panel panel-default">
			<div class="panel-heading clearfix"
			     :class="{'error':menu.errorMessage}"
			     @click.stop.prevent="levelClick(menu)">
				<div class="pull-left">
					<span>
						{{menu.name?menu.name:"请填写菜单名称"}}
					</span>
					<span class="ml10" v-if="menu.type === 'ARTICLE' || menu.type === 'PERSON' || menu.type === 'SCENERY' || menu.type === 'PARENT'">
						{{menu.getUrlBase()}}<span class="label-attribute">{{menu.location}}</span>
					</span>
					<span class="ml10 label-link" v-if="menu.type === 'TOPIC'">
						<i class="fa fa-ravelry"></i>
						/{{menu.topic.location}}
					</span>
					<span class="ml10 label-topic" v-if="menu.type === 'URL'">
						<i class="fa fa-link"></i>
						{{menu.url}}
					</span>

				</div>
				<div class="pull-right">

					<ActionButtons :index="index" :menu="menu" :container="container" :editMode="editMode"/>

				</div>

			</div>

			<NbExpanding>
				<PanelBody v-if="menu.editMode" :menu="menu" :container="container"/>
			</NbExpanding>


		</div>


		<LevelBlock v-for="(attr,attrIndex) in menu.menus" :key="attr" :menu="attr" :index="attrIndex"
		            :container="menu.menus"
		            :editMode="editMode"/>

	</div>

</template>

<script>
	import TopicMenu from '../../../../common/model/topic/TopicMenu'
	import ActionButtons from "./ActionButtons.vue"
	import PanelBody from "./PanelBody.vue"
	import NbExpanding from '../../../../common/widget/NbExpanding.vue'
	export default {
		//利用name，进行递归。
		name: 'LevelBlock',
		data(){
			return {}
		},
		props: {
			editMode: {
				type: Boolean,
				required: false,
				"default": false
			},
			menu: {
				type: TopicMenu,
				required: false
			},
			container: {
				type: Array,
				required: true
			},
			index: {
				type: Number,
				required: true
			}

		},
		components: {
			ActionButtons,
			PanelBody,
			NbExpanding
		},
		computed: {},
		watch: {},
		methods: {
			levelClick(menu){
				if (this.editMode) {
					menu.toggleEdit();
				}
			}
		},
		mounted(){
		}
	}
</script>


// WEBPACK FOOTER //
// LevelBlock.vue?7a27d348